// JsFromRoutes CacheKey fe108d7f33b8e017980d31979476365d
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/admin'),
}
